import { MenuItem, TextField } from '@material-ui/core';
import { TextFieldProps } from '@material-ui/core/TextField';
import { makeStyles, Theme } from '@material-ui/core/styles';
import React from 'react';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    '& .MuiOutlinedInput-root': {
      '&:hover fieldset': {
        borderColor: '#264259',
      },
    },
  },
  input: {
    color: theme.palette.primary.main,
    fontSize: 14,
  },
  textField: {
    marginBottom: theme.spacing(1),
  },
  menuItem: {
    color: theme.palette.primary.main,
    fontSize: 14,
  },
}));

interface ItemSelect {
  titulo?: string;
  valor?: string | number | null;
  label?: string;
  value?: string | number | null;
}

interface TextSelectProps {
  itens: ItemSelect[];
  getOptionLabel?: (option: ItemSelect) => string;
}

const Select: React.FC<TextFieldProps & TextSelectProps> = props => {
  const { itens, value, onChange, label, required, inputProps, InputLabelProps, ...rest } = props;
  const classes = useStyles();

  const normalized = itens.map((opt, i) => {
    const titulo = opt.titulo ?? opt.label ?? '';
    const valorRaw = opt.valor ?? opt.value;
    return {
      key: i,
      titulo,
      valor:
        valorRaw !== undefined &&
        valorRaw !== null &&
        valorRaw !== ' ' &&
        valorRaw !== ''
          ? valorRaw
          : titulo,
    };
  });

  return (
    <TextField
      select
      variant="outlined"
      fullWidth
      label={label}
      value={value ?? ''}
      onChange={onChange}
      InputProps={{
        className: classes.input,
      }}
      className={classes.textField}
      {...rest}
      InputLabelProps={{ ...InputLabelProps, required: Boolean(required) }}
      inputProps={{ ...inputProps, required: undefined }}
    >
      <MenuItem value="">
        <em>Selecione...</em>
      </MenuItem>

      {normalized.map(item => (
        <MenuItem key={item.key} value={item.valor} className={classes.menuItem}>
          {item.titulo}
        </MenuItem>
      ))}
    </TextField>
  );
};

export default Select;
